import { gql } from "@apollo/client";
import { MEDIA_ITEM_FRAGMENT } from "./MediaItemFragment";

export const EVENT_FEED_FRAGMENT = gql`
  fragment EventFeedFragment on Event {
    id
    title
    content
    uri
    eventOptions {
      multipleDays
      featured
      dateRange {
        date
      }
      link {
        title
        target
        url
      }
      multiDays {
        date
        startTime
        endTime
      }
      startTime
      endTime
      date
      customAddressLabel
      address {
        city
        country
        countryShort
        latitude
        longitude
        placeId
        postCode
        state
        stateShort
        streetAddress
        streetName
        streetNumber
        zoom
      }
      schedule {
        startTime
        label
        endTime
      }
    }
    featuredImage {
      node {
        ...MediaItemFragment
      }
    }
  }
  ${MEDIA_ITEM_FRAGMENT}
`;
